import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem } from '@domain-group/suit-theme'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import { confirmDelete } from '@functions/entity'

import useOrderBundleItem from '@hooks/useOrderBundleItem'
import { generateUrls } from '@hooks/useServiceProduct'

interface OrderBundleProductActionsProps {
  currentProviderId: number,
  isAdmin: boolean,
  orderBundleItem: {
    id: number,
  },
}

const OrderBundleProductActions = (props: OrderBundleProductActionsProps) => {
  const { currentProviderId, isAdmin, orderBundleItem } = props

  const OrderBundleItemPayload = useOrderBundleItem(orderBundleItem)
  const {
    callbacks: {
      createOrEditOrderBundleItem,
      deleteOrderBundleItem: deleteFn,
    },
    orderBundleItem: { provider_id, service_product_id },
  } = OrderBundleItemPayload

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    options: { shouldRedirect: true },
    strings: { deleteString: 'remove', entityName: 'Order Bundle Item' },
  }

  const { editServiceProductUrl } = generateUrls({ id: service_product_id })

  if (!isAdmin && currentProviderId !== provider_id) return null

  return (
    <Box justifyContent="flex-end">
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        marginRight="medium"
        onClick={() => createOrEditOrderBundleItem()}
        type="edit"
      />

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        marginRight={isAdmin ? 'medium' : 'none'}
        // @ts-expect-error TS2345
        onClick={() => confirmDelete(confirmDeletePayload)}
        type="delete"
      />

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editServiceProductUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
      </ScopedConditionalContent>
    </Box>
  )
}

export default OrderBundleProductActions
